import React, { Component } from 'react';
import axios from 'axios'
import { Buffer } from 'buffer';
import { Card, Dropdown, DropdownButton, Row, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import Pagination from "../components/pagination"
import { orderStatus, initialSliceStatus } from '../utils';
import fileSaver from "file-saver";
import b64ToBlob from "b64-to-blob";

class Orders extends Component {
    state = {
        jobs: [],
        imageSrcArray: {},
        downloadInProgress: false,
        queriedCount: 0,
        currentPage: 1,
        filterOrderStatus: null,
        filterPaymentStatusOptions: null
    }

    componentDidMount() {

        this.pollJobsByQuery()
        document.addEventListener("visibilitychange", this.handleVisibilityChange)

    }

    componentWillUnmount() {
        this.isUnmounted = true
        clearTimeout(this.pollTimeout)
        document.removeEventListener("visibilitychange", this.handleVisibilityChange)
    }

    handleVisibilityChange = () => {
        if (document.hidden) {
            clearTimeout(this.pollTimeout)
        } else {
            this.pollJobsByQuery()
        }
    }

    pollJobsByQuery = async () => {
        clearTimeout(this.pollTimeout)
        if (this.isUnmounted || document.hidden) return
        await this.getJobsByQuery()
        if (this.isUnmounted || document.hidden) return
        this.pollTimeout = setTimeout(this.pollJobsByQuery, 10000)
    }
    getJobsByQuery = () => {
        return axios.post("/api/jobs/admin/get/count/by/query", { orderStatus: this.state.filterOrderStatus, paymentStatus: this.state.filterPaymentStatusOptions }).then(res => {
            return new Promise(resolve => {
                this.setState({ queriedCount: res.data.count }, () => {
                    axios.post("/api/jobs/admin/paginate/with/query", { count: 10, page: this.state.currentPage - 1, orderStatus: this.state.filterOrderStatus, paymentStatus: this.state.filterPaymentStatusOptions }).then(res => {
                        if (res.data.success) {
                            this.setState({ jobs: res.data.jobs })
                        }
                        resolve()
                    })
                })
            })
        })
    }
    getModelImage = async (job) => {

        if (!job.model) {
            return
        }
        let res = await axios.post('/api/model/admin/image/by/filename', { job: job._id }, { responseType: 'arraybuffer' }).then(res => {
            const base64 = Buffer.from(res.data, 'binary').toString('base64');
            const contentType = res.headers['content-type'] || 'image/png'; // fallback to PNG
            const imageSrc = `data:${contentType};base64,${base64}`;
            this.setState({
                imageSrcArray: {
                    ...this.state.imageSrcArray,
                    [job.model]: imageSrc
                }
            });
        }).catch(err => {

        })


    }
    setJobStatus = (job, status) => {
        axios.post("/api/jobs/set/status", { job: job, status: status }).then(res => {
            this.getJobsByQuery()

        })
    }

    setInitialSliceStatus = (job, status) => {
        axios.post("/api/jobs/set/initial/slice/status", { job: job, status: status }).then(res => {
            this.getJobsByQuery()
        })
    }
    downloadGcode = (id) => {
        fetch('/api/jobs/download/gcode', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.jwtToken
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({ jobid: id })
        }).then((response) => {
            if (!response.ok) {
                return response.text().then(text => { throw new Error(`Server error ${response.status}: ${text}`) })
            }
            return response.text();
        })
            .then((zipAsBase64) => {
                const blob = b64ToBlob(zipAsBase64, "application/gcode");

                fileSaver.saveAs(blob, `${id}.gcode`);
                this.setState({ downloadInProgress: false })
            }).catch(err => {
                console.error('Gcode download failed:', err)
                alert(err.message)
            })
    }
    changePage = (page) => {
        this.setState({ currentPage: page }, () => {
            this.getJobsByQuery()
        })
    }

    setOrderStatusFilter = (id) => {
        this.setState({ filterOrderStatus: id }, () => {
            this.getJobsByQuery()
        })
    }
    setOrderPaymentStatusFilter = (id) => {
        this.setState({ filterPaymentStatusOptions: id }, () => {
            this.getJobsByQuery()
        })
    }


    render() {
        let jobs = []
        let darkmode = this.props.user ? this.props.user.darkmode : true
        let pages = Math.ceil(this.state.queriedCount / 10)
        let filterPaymentStatusOptions = {
            "paid": "paid",
            "pending": "pending"
        }

        let filterStatusOptions = []
        filterStatusOptions.push(
            <Dropdown.Item onClick={() => this.setOrderStatusFilter(null)}>{"All"}</Dropdown.Item>)
        Object.entries(orderStatus).forEach(entry => {
            const [id, status] = entry;
            filterStatusOptions.push(
                <Dropdown.Item onClick={() => this.setOrderStatusFilter(id)}>{status}</Dropdown.Item>)
        });

        let filterPaymentStatusOptionsHtml = []
        filterPaymentStatusOptionsHtml.push(
            <Dropdown.Item onClick={() => this.setOrderPaymentStatusFilter(null)}>{"All"}</Dropdown.Item>)
        Object.entries(filterPaymentStatusOptions).forEach(entry => {
            const [id, status] = entry;
            filterPaymentStatusOptionsHtml.push(
                <Dropdown.Item onClick={() => this.setOrderPaymentStatusFilter(id)}>{status}</Dropdown.Item>)
        });

        for (let job of this.state.jobs) {

            let statusOptions = []
            Object.entries(orderStatus).forEach(entry => {
                const [id, status] = entry;
                statusOptions.push(
                    <Dropdown.Item onClick={() => this.setJobStatus(job._id, id)}>{status}</Dropdown.Item>)
            });





            let initialSliceStatusOptions = []

            Object.entries(initialSliceStatus).forEach(entry => {
                const [id, status] = entry;
                initialSliceStatusOptions.push(
                    <Dropdown.Item onClick={() => this.setInitialSliceStatus(job._id, id)}>{status}</Dropdown.Item>)

            });
            if (!this.state.imageSrcArray[job.model]) {
                this.getModelImage(job)
            }

            jobs.push(
                <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ margin: "20px", padding: "20px" }}>
                    <div >
                        <div style={{
                            margin: "10px auto",
                            width: "300px",
                            display: "block"
                        }}>
                            <img style={{ width: "200px" }} src={this.state.imageSrcArray[job.model]} alt="Model" className="mt-4 border rounded" />
                        </div>
                        <div style={{ flex: 1 }}>
                            <p>
                                Model: {job.model}
                            </p>
                            <p>
                                Filament: {job.filament}
                            </p>
                            <p>
                                Payment Status: {job.paymentStatus}
                            </p>
                            <p>
                                Price: £{job.price}
                            </p>
                            <DropdownButton style={{ margin: "20px" }} align="end" title={"Status: " + orderStatus[job.printStatus]} variant="primary">
                                <div style={{ height: '200px', overflow: 'auto', maxWidth: "80vw" }}>
                                    {statusOptions}
                                </div>
                            </DropdownButton>

                            <DropdownButton style={{ margin: "20px" }} align="end" title={"Initial Slice Status: " + initialSliceStatus[job.initialSliceStatus]} variant="primary">
                                <div style={{ height: '200px', overflow: 'auto', maxWidth: "80vw" }}>
                                    {initialSliceStatusOptions}
                                </div>
                            </DropdownButton>
                            <p>
                                Shipping: {job.shipping ? job.shipping : "None Selected"}
                            </p>
                            <Row style={{ margin: "auto", margin: "20px" }}>
                                <Col style={{ margin: "auto" }}>
                                    <Button style={{ width: "100%" }} onClick={() => this.downloadGcode(job._id)}>Download GCODE</Button>
                                </Col>
                            </Row>
                        </div>
                    </div>


                </Card>


            )
        }

        return (
            <div style={{ width: "100%", margin: "auto", textAlign: "center", maxWidth: "1000px" }}>
                <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ margin: "20px", padding: "20px" }}>
                    <Row>
                        <Col>
                            Total: {this.state.queriedCount}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <DropdownButton style={{ margin: "20px" }} align="end" title={"Filter Order Status: " + (orderStatus[this.state.filterOrderStatus] ? orderStatus[this.state.filterOrderStatus] : "All")} variant="primary">
                                <div style={{ height: '200px', overflow: 'auto', maxWidth: "80vw" }}>
                                    {filterStatusOptions}
                                </div>
                            </DropdownButton>
                        </Col>
                        <Col>
                            <DropdownButton style={{ margin: "20px" }} align="end" title={"Filter Order Payment Status: " + (filterPaymentStatusOptions[this.state.filterPaymentStatusOptions] ? filterPaymentStatusOptions[this.state.filterPaymentStatusOptions] : "All")} variant="primary">
                                <div style={{ height: '200px', overflow: 'auto', maxWidth: "80vw" }}>
                                    {filterPaymentStatusOptionsHtml}
                                </div>
                            </DropdownButton>
                        </Col>
                    </Row>
                </Card>
                {jobs}
                <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ margin: "20px", padding: "20px" }}>
                    <Pagination changePage={this.changePage} currentPage={this.state.currentPage} pages={pages} />
                </Card>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Orders);